import styles from './account-menu.module.scss';
import * as React from 'react';
import { Divider } from '@mui/material';
import { WButton, WListItemIcon, WMenu, WMenuItem } from '../../wrappers/wrapper';
import { useNavigate } from 'react-router-dom';
import ProfileDialog from '../profile-dialog/profile-dialog';
import { useContext } from 'react';
import { UserContext } from '../../../contexts/userContext';
import ProfilePhoto from '../../molecules/profile-photo/profile-photo';
import { Authentication } from '../../../services/auth.service';
import { localStorageService, STORAGE_KEY } from '../../../services/local-storage.service';
import Logout from '@mui/icons-material/Logout';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import ViewProfile from '../view-profile-popover/view-profile-popover';

function AccountMenu() {
  const authentication = new Authentication();
  const navigate = useNavigate();
  const [openProfileDialog, setOpenProfileDialog] = React.useState(false);
  const [openViewProfile, setOpenViewProfile] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState(0);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const { user } = useContext(UserContext);

  const openPopover = Boolean(anchorEl);
  const id = openPopover ? 'simple-popover' : undefined;
  const userJson = localStorageService.getItem(STORAGE_KEY.USER);
  const initialLocalUser = userJson ? JSON.parse(userJson) : {};
  const userId = initialLocalUser._id;

  const handleChangeTab = (tabIndex: number) => {
    setActiveTab(tabIndex);
  };

  const handleSignOut = () => {
    authentication.logOut();
    navigate('/home');
    window.location.reload();
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenProfileDialog = (tabIndex: number) => {
    setActiveTab(tabIndex);
    setOpenProfileDialog(true);
  };

  const handleCloseProfileDialog = () => {
    setOpenProfileDialog(false);
  };

  const handleOpenViewProfile = () => {
    handleClose();
    setTimeout(() => {
      setOpenViewProfile(true);
    }, 250)
  };

  return (
    <>
      {openViewProfile && (
        <ViewProfile
          user_id={userId}
          onClose={() => setOpenViewProfile(false)}
          showEditButton={true}
        />
      )}
      <WButton
        disableRipple
        sx={{
          minWidth: 'unset',
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
        aria-describedby={id}
        variant="text"
        onClick={handleClick}
      >
        <ProfilePhoto
          width="32px"
          height="32px"
          radius="100%"
          fontSize="0.9rem"
          user={user ? user : 'loading ... '}
        />
      </WButton>
      <WMenu
        anchorEl={anchorEl}
        open={openPopover}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              border: 'var(--border)',
              padding: '1rem',
              width: '14rem',
              borderRadius: 'var(--border-radius)',
              backgroundColor: 'var(--color-content-background)',
              color: 'var(--color-white)',
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        className={styles.menu}
      >
        <WMenuItem onClick={handleOpenViewProfile}>
          <WListItemIcon>
            <Person2OutlinedIcon style={{color:"var(--color-white)"}} />
          </WListItemIcon>
          View Profile
        </WMenuItem>
        <WMenuItem onClick={() => handleOpenProfileDialog(0)}>
          <WListItemIcon>
            <EditOutlinedIcon style={{color:"var(--color-white)"}} />
          </WListItemIcon>
          Edit Profile
        </WMenuItem>
        <WMenuItem onClick={() => handleOpenProfileDialog(1)}>
          <WListItemIcon>
            <NotificationsNoneOutlinedIcon style={{color:"var(--color-white)"}} />
          </WListItemIcon>
          Notifications
        </WMenuItem>
        <WMenuItem onClick={() => handleOpenProfileDialog(2)}>
          <WListItemIcon>
            <LockOpenOutlinedIcon style={{color:"var(--color-white)"}} />
          </WListItemIcon>
          Authentication
        </WMenuItem>
        <Divider style={{border:"var(--border-light)"}} />
        <WMenuItem onClick={handleSignOut}>
          <WListItemIcon>
            <Logout style={{color:"var(--color-white)"}} fontSize="small" />
          </WListItemIcon>
          Sign out
        </WMenuItem>
      </WMenu>

      <ProfileDialog
        open={openProfileDialog}
        onClose={handleCloseProfileDialog}
        activeTab={activeTab}
        onTabChange={handleChangeTab}
      />
    </>
  );
}
export default AccountMenu;
